module.exports = __webpack_public_path__ + "static/media/new_order.2b92a0ec.svg";